// src/components/reader/ProgressControls.jsx
//
// Manual progress controls shared by the readers (reader-manual-progress slice).
// Progress is now PURELY manual -- opening a section no longer marks it; the
// user ticks items themselves. Two on-theme (book-*) controls, both driven by
// the same completedSet so the sidebar tick and the section button stay in sync:
//
//   ItemTickButton        -- a small left-side checkbox in a sidebar item row.
//                            stopPropagation so ticking never triggers the row's
//                            "open this section" navigation.
//   SectionCompleteToggle -- a "Mark complete" / "Done" button for the section
//                            content area (toggles the current item).
import React from 'react';
import { IconCheck } from '../icons.jsx';

// Sidebar per-item tick. A DISTINCT click target from the row: onClick stops
// propagation so the parent row's open-section handler does not also fire.
export function ItemTickButton({ complete, onToggle, label }) {
    const title = complete ? 'Mark not done' : 'Mark done';
    return (
        <button type="button"
            onClick={(e) => { e.stopPropagation(); onToggle(); }}
            aria-pressed={complete}
            title={title}
            aria-label={title + (label ? ': ' + label : '')}
            className={`flex-shrink-0 w-4 h-4 rounded-full border flex items-center justify-center cursor-pointer transition-colors ${
                complete
                    ? 'bg-book-accent border-book-accent text-black'
                    : 'border-book-accent/40 text-transparent hover:border-book-accent hover:bg-book-accent/10'
            }`}>
            <IconCheck className="w-2.5 h-2.5" />
        </button>
    );
}

// Section-content toggle: "Mark complete" (incomplete) <-> "Done" (complete).
export function SectionCompleteToggle({ complete, onToggle }) {
    return (
        <button type="button" onClick={onToggle} aria-pressed={complete}
            className={`inline-flex items-center gap-2 px-3 py-1.5 border font-display text-sm transition-colors font-medium rounded-full ${
                complete
                    ? 'border-book-accent bg-book-accent/10 text-book-accent'
                    : 'border-book-accent/40 text-book-muted hover:text-book-accent hover:border-book-accent'
            }`}>
            <span className={`w-3.5 h-3.5 rounded-full border flex items-center justify-center ${
                complete ? 'bg-book-accent border-book-accent text-black' : 'border-current'
            }`}>
                {complete && <IconCheck className="w-2.5 h-2.5" />}
            </span>
            {complete ? 'Done' : 'Mark complete'}
        </button>
    );
}
